export default __webpack_public_path__ + "static/media/android.62b8989e.svg";